/**
 * @generated SignedSource<<996e7ab262974a936f3676b38f5d2c1e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AccountGroupAccountChangesInput = {
  accounts: ReadonlyArray<AccountInput>;
  id: string;
};
export type AccountInput = {
  financialAccountId: number;
  id: any;
};
export type AddAccountsToAccountGroupMutation$variables = {
  input: AccountGroupAccountChangesInput;
};
export type AddAccountsToAccountGroupMutation$data = {
  readonly AddAccountsToAccountGroup: {
    readonly accountGroup: {
      readonly accounts: ReadonlyArray<{
        readonly financialAccountId: number;
        readonly id: any;
      }>;
      readonly id: string;
      readonly name: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly message: string;
    }> | null;
  };
};
export type AddAccountsToAccountGroupMutation = {
  response: AddAccountsToAccountGroupMutation$data;
  variables: AddAccountsToAccountGroupMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "AccountGroup",
  "kind": "LinkedField",
  "name": "accountGroup",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "accounts",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "financialAccountId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddAccountsToAccountGroupMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountGroupPayload",
        "kind": "LinkedField",
        "name": "AddAccountsToAccountGroup",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddAccountsToAccountGroupMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountGroupPayload",
        "kind": "LinkedField",
        "name": "AddAccountsToAccountGroup",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8211446a9d801eb5499683e27bce5e5f",
    "id": null,
    "metadata": {},
    "name": "AddAccountsToAccountGroupMutation",
    "operationKind": "mutation",
    "text": "mutation AddAccountsToAccountGroupMutation(\n  $input: AccountGroupAccountChangesInput!\n) {\n  AddAccountsToAccountGroup(input: $input) {\n    accountGroup {\n      id\n      name\n      accounts {\n        id\n        financialAccountId\n      }\n    }\n    errors {\n      __typename\n      message\n      code\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d58fa16641f374e790f6af981821bd60";

export default node;
